export enum NotificationTypes {
  Info = 'info',
  Error = 'error',
  Success = 'success',
  Warning = 'warning'
}
